const STORAGE_KEY = 'crmCollapsedOrders'

function readFromStorage () {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY))
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

function writeToStorage (items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  } catch (e) {
    // приватный режим или переполнение - работаем без персиста
  }
}

const state = {
  items: readFromStorage(),
}

const getters = {
  byBasketId: (state) => (basketId) => {
    return state.items.find((item) => item.basketId === Number(basketId))
  },
}

const mutations = {
  upsert (state, entry) {
    const index = state.items.findIndex((item) => item.basketId === entry.basketId)
    if (index === -1) {
      state.items.push(entry)
    } else {
      state.items.splice(index, 1, entry)
    }
    writeToStorage(state.items)
  },
  remove (state, basketId) {
    state.items = state.items.filter((item) => item.basketId !== Number(basketId))
    writeToStorage(state.items)
  },
}

const actions = {
  collapseCurrent ({ commit, rootState }) {
    const basket = rootState.baskets.basket
    if (!basket || !basket.id) {
      return
    }
    commit('upsert', {
      basketId: basket.id,
      step: rootState.newOrder.currentStep,
      clientName: (basket.client && basket.client.name) || null,
      totalPrice: basket.totalPrice || 0,
      deliveryType: basket.deliveryType || null,
      collapsedAt: Date.now(),
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
